import {useContext} from 'react';
import {ModalContext, ModalContextType} from '@shortsworks/ui/components/modal';

export function useModal(): ModalContextType {
  const context = useContext(ModalContext);
  if (!context) {
    throw new Error('useModal must be used within a ModalProvider');
  }
  return context;
}
